import { useFormik } from "formik";
import * as Yup from "yup";

const Signup3 = ({
  handlePage,
  handleFirstNameChange,
  handleLastNameChange,
  handleContactNumberChange,
  handleCreatePasswordChange,
  handleConfirmPasswordChange,
  handleEqualCheckPassword,
}) => {
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    contactNumber: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(10, "Must be at least 10 digits")
    .max(15, "Must be at most 15 digits")
    .required("Required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      contactNumber: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: () => {
      handleEqualCheckPassword();
    },
  });

  return (
    <>
      <div className="font-hk flex flex-col justify-center items-center h-screen bg-black bg-opacity-70">
        <div className="relative max-w-xl bg-white p-8 rounded-lg shadow-md justify-around w-[95vw] md:w-[44vw] ">
          <button
            className="absolute z-[110] top-3 right-3 text-[30px]"
            onClick={() => {
              handlePage(-1);
            }}
          >
            <i className="fa-regular fa-circle-xmark"></i>
          </button>
          <h1 className="text-3xl font-bold mb-4">Register your Account</h1>
          <h2 className="text-lg font-semibold mb-6">
            Please provide the following details:
          </h2>
          <form className="space-y-4" onSubmit={formik.handleSubmit}>
            <div>
              <label
                htmlFor="first-name"
                className="block text-gray-700 font-medium mb-2"
              >
                First Name
              </label>
              <input
                id="first-name"
                name="firstName"
                onChange={(e) => {
                  formik.handleChange(e);
                  handleFirstNameChange(e);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.firstName}
                type="text"
                placeholder="Enter your first name"
                className="w-full border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <p className="text-red-500 text-sm">
                  {formik.errors.firstName}
                </p>
              )}
            </div>
            <div>
              <label
                htmlFor="last-name"
                className="block text-gray-700 font-medium mb-2"
              >
                Last Name
              </label>
              <input
                id="last-name"
                name="lastName"
                onChange={(e) => {
                  formik.handleChange(e);
                  handleLastNameChange(e);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
                type="text"
                placeholder="Enter your last name"
                className="w-full border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <p className="text-red-500 text-sm">
                {formik.errors.lastName}
                </p>
                )}
                </div>
                <div>
                <label
                             htmlFor="contact-number"
                             className="block text-gray-700 font-medium mb-2"
                           >
                Contact Number
                </label>
                <input
                             id="contact-number"
                             name="contactNumber"
                             onChange={(e) => {
                              formik.handleChange(e);
                              handleContactNumberChange(e);
                            }}
                             onBlur={formik.handleBlur}
                             value={formik.values.contactNumber}
                             type="tel"
                             placeholder="Enter your contact number"
                             className="w-full border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                           />
                {formik.touched.contactNumber && formik.errors.contactNumber && (
                <p className="text-red-500 text-sm">
                {formik.errors.contactNumber}
                </p>
                )}
                </div>
                <div>
                <label
                             htmlFor="password"
                             className="block text-gray-700 font-medium mb-2"
                           >
                Create Password
                </label>
                <input
                             id="password"
                             name="password"
                             onChange={(e) => {
                              formik.handleChange(e);
                              handleCreatePasswordChange(e);
                            }}
                             onBlur={formik.handleBlur}
                             value={formik.values.password}
                             type="password"
                             placeholder="Create a password"
                             className="w-full border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                           />
                {formik.touched.password && formik.errors.password && (
                <p className="text-red-500 text-sm">
                {formik.errors.password}
                </p>
                )}
                </div>
                <div>
                <label
                             htmlFor="confirm-password"
                             className="block text-gray-700 font-medium mb-2"
                           >
                Confirm Password
                </label>
                <input
                             id="confirm-password"
                             name="confirmPassword"
                             onChange={(e) => {
                              formik.handleChange(e);
                              handleConfirmPasswordChange(e);
                            }}
                             onBlur={formik.handleBlur}
                             value={formik.values.confirmPassword}
                             type="password"
                             placeholder="Confirm your password"
                             className="w-full border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                           />
                {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                <p className="text-red-500 text-sm">
                {formik.errors.confirmPassword}
                </p>
                )}
                </div>
                <button
                           type="submit"
                           className="bg-black text-white py-2 px-4 rounded-md hover:bg-gray-900"
                         >
                Signup
                </button>
                </form>
                </div>
                </div>
                </>
                );
                };
                
                export default Signup3;
